"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionProps = exports.QR_CODE_DIALOG = void 0;
const QR_CODE_DIALOG = exports.QR_CODE_DIALOG = 'qr-code-dialog';
const transitionProps = exports.transitionProps = {
  timeout: 0
};
